import Vue from "vue";

import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faAngleDoubleDown,
    faAngleDoubleRight,
    faArrowAltCircleDown,
    faArrowAltCircleUp,
    faArrowRight,
    faBan,
    faBars,
    faBell,
    faBoxes,
    faCalendar,
    faCheck,
    faCheckCircle,
    faCloudUploadAlt,
    faCode,
    faCog,
    faCompressArrowsAlt,
    faCopy,
    faEdit,
    faEllipsisV,
    faEuroSign,
    faExpandArrowsAlt,
    faExternalLinkAlt,
    faFile,
    faFileDownload,
    faFileImport,
    faFont,
    faHashtag,
    faHistory,
    faImage,
    faInfo,
    faKey,
    faLayerGroup,
    faLink,
    faMinus,
    faPaperclip,
    faPlus,
    faPrint,
    faProjectDiagram,
    faReplyAll,
    faShare,
    faTimes,
    faToggleOn,
    faTrashAlt,
    faUpload,
    faUser,
    faUserFriends,
    faUsers,
    faUserSecret,
    faToggleOff
} from "@fortawesome/free-solid-svg-icons";
import {faCalendarCheck, faComment, faCopy as faCopyRegular, faFileExcel, faFlag, faHandPaper, faThumbsUp} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from "@fortawesome/vue-fontawesome";

library.add(
    faComment,
    faCalendarCheck,
    faCloudUploadAlt,
    faUsers,
    faUserSecret,
    faThumbsUp,
    faHandPaper,
    faFileDownload,
    faCheckCircle,
    faFile,
    faPlus,
    faEdit,
    faMinus,
    faPrint,
    faUserFriends,
    faArrowAltCircleUp,
    faArrowAltCircleDown,
    faBan,
    faAngleDoubleRight,
    faAngleDoubleDown,
    faBell,
    faCopy,
    faTrashAlt,
    faKey,
    faFileExcel,
    faCog,
    faTimes,
    faCheck,
    faBars,
    faEllipsisV,
    faInfo,
    faFlag,
    faImage,
    faCode,
    faShare,
    faHistory,
    faCalendar,
    faExternalLinkAlt,
    faFont,
    faHashtag,
    faFileImport,
    faLink,
    faExpandArrowsAlt,
    faCompressArrowsAlt,
    faReplyAll,
    faPaperclip,
    faUpload,
    faProjectDiagram,
    faLayerGroup,
    faUser,
    faArrowRight,
    faCopyRegular,
    faEuroSign,
    faBoxes,
    faToggleOn,
    faToggleOff
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);
